export enum DestTransferStrategy {
  NotSelected = "",
  SplitEvenly = "Split Evenly",
  MaximizeVolume = "Maximize Volume",
  Custom = "Custom",
}
